import { useState } from "react";
import "./checkout.css";
import image from "./image.png";
import {
  LayoutGrid,
  Car,
  LogIn,
  LogOut,
  BarChart3,
  Settings,
  Wallet,
  CreditCard,
  Smartphone,
  Printer,
  Eye,
  Pencil,
  SlidersHorizontal,
  Search,
} from "lucide-react";

function VehicleListPage({
  currentPage,
  setCurrentPage,
  setPage
}) {
  const vehicles = [
    {
      id: "#ENT-9821",
      initials: "TN",
      number: "TN-68-AH9876",
      duration: "02h 15m",
      status: "Active",
    },
    {
      id: "#ENT-9815",
      initials: "TN",
      number: "TN-68-BX4567",
      duration: "05h 42m",
      status: "Overtime",
    },
    {
      id: "#ENT-9809",
      initials: "KA",
      number: "KA-68-AH9876",
      duration: "00h 48m",
      status: "Active",
    },
    {
      id: "#ENT-9804",
      initials: "KA",
      number: "KA-68-AH9876",
      duration: "00h 48m",
      status: "Active",
    },
    {
      id: "#ENT-9798",
      initials: "KA",
      number: "KA-68-AH9876",
      duration: "00h 48m",
      status: "Active",
    },
  ];

  return (
    <div className="vehicle-wrapper">
      {/* Sidebar */}
      <Sidebar
  activeNav="checkout"
  setActiveNav={() => {}}
  setPage={setPage}
/>

      {/* Content */}
      <main className="vehicle-content">
        <h1>Check-Out</h1>

        <p className="vehicle-subtitle">
          FINALISE AND EXIT THE VEHICLE FROM PARKING
        </p>

        <h2 className="occupied-title">All Vehicles - Occupied</h2>

        <div className="table-card">
          <div className="table-top">
            <h3>Current Vehicles</h3>

            <div className="search-filter-group">
              <div className="search-wrapper">
                <Search size={16} className="search-icon" />
                <input
                  className="search-box"
                  placeholder="Search vehicle by Entry ID or Vehicle Number"
                />
              </div>
              <button className="filter-btn" title="Filter">
                <SlidersHorizontal size={18} />
              </button>
            </div>
          </div>

          <table>
            <thead>
              <tr>
                <th>ENTRY ID</th>
                <th>VEHICLE NUMBER</th>
                <th>DURATION</th>
                <th>STATUS</th>
                <th>ACTIONS</th>
              </tr>
            </thead>

            <tbody>
              {vehicles.map((vehicle, index) => (
                <tr key={`${vehicle.id}-${index}`}>
                  <td className="entry-id-cell">{vehicle.id}</td>

                  <td>
                    <div className="vehicle-number-cell">
                      <span className="vehicle-initials-badge">
                        {vehicle.initials}
                      </span>
                      <span>{vehicle.number}</span>
                    </div>
                  </td>

                  <td
                    className={
                      vehicle.status === "Overtime" ? "duration-red" : ""
                    }
                  >
                    {vehicle.duration}
                  </td>

                  <td>
                    <span
                      className={
                        vehicle.status === "Overtime"
                          ? "status overtime"
                          : "status active-status"
                      }
                    >
                      {vehicle.status === "Overtime" ? (
                        <span className="status-dot red-dot" />
                      ) : (
                        <span className="status-dot green-dot" />
                      )}
                      {vehicle.status}
                    </span>
                  </td>

                  <td className="actions-cell">
                    <button className="view-btn icon-btn" title="View">
                      <Eye size={15} />
                      <span>View</span>
                    </button>

                    <button className="exit-btn icon-btn" title="Edit">
                      <Pencil size={14} />
                      <span>Edit</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="pagination">
            <span className="entries-info">Showing 3 of 2,096 Entries</span>

            <div className="pagination-buttons">
              <button
  className="page-nav-btn"
  onClick={() => setCurrentPage("checkin")}
>
  Previous
</button>
              <button className="page-nav-btn page-nav-active">Next Page</button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

/* ─── Sidebar (shared across all screens) ────────────── */

function Sidebar({ activeNav, setActiveNav, setPage }) {
  const items = [
    { id: "dashboard", label: "Dashboard", icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M10 6V0H18V6H10ZM0 10V0H8V10H0ZM10 18V8H18V18H10ZM0 18V12H8V18H0ZM2 8H6V2H2V8ZM12 16H16V10H12V16ZM12 4H16V2H12V4ZM2 16H6V14H2V16Z" fill="currentColor"/></svg> },
    { id: "vehicles",  label: "Vehicles",  icon: <svg width="18" height="16" viewBox="0 0 18 16" fill="none"><path d="M3 14V15C3 15.2833 2.90417 15.5208 2.7125 15.7125C2.52083 15.9042 2.28333 16 2 16H1C0.716667 16 0.479167 15.9042 0.2875 15.7125C0.0958333 15.5208 0 15.2833 0 15V7L2.1 1C2.2 0.7 2.37917 0.458333 2.6375 0.275C2.89583 0.0916667 3.18333 0 3.5 0H14.5C14.8167 0 15.1042 0.0916667 15.3625 0.275C15.6208 0.458333 15.8 0.7 15.9 1L18 7V15C18 15.2833 17.9042 15.5208 17.7125 15.7125C17.5208 15.9042 17.2833 16 17 16H16C15.7167 16 15.4792 15.9042 15.2875 15.7125C15.0958 15.5208 15 15.2833 15 15V14H3ZM2.8 5H15.2L14.15 2H3.85L2.8 5ZM2 7V12V7ZM4.5 11C4.91667 11 5.27083 10.8542 5.5625 10.5625C5.85417 10.2708 6 9.91667 6 9.5C6 9.08333 5.85417 8.72917 5.5625 8.4375C5.27083 8.14583 4.91667 8 4.5 8C4.08333 8 3.72917 8.14583 3.4375 8.4375C3.14583 8.72917 3 9.08333 3 9.5C3 9.91667 3.14583 10.2708 3.4375 10.5625C3.72917 10.8542 4.08333 11 4.5 11ZM13.5 11C13.9167 11 14.2708 10.8542 14.5625 10.5625C14.8542 10.2708 15 9.91667 15 9.5C15 9.08333 14.8542 8.72917 14.5625 8.4375C14.2708 8.14583 13.9167 8 13.5 8C13.0833 8 12.7292 8.14583 12.4375 8.4375C12.1458 8.72917 12 9.08333 12 9.5C12 9.91667 12.1458 10.2708 12.4375 10.5625C12.7292 10.8542 13.0833 11 13.5 11ZM2 12H16V7H2V12Z" fill="currentColor"/></svg> },
    { id: "checkin",   label: "Check-In",  icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M8.55 17.1V15.2H15.2V1.9H8.55V0H15.2C15.7225 0 16.1698 0.186042 16.5419 0.558125C16.914 0.930208 17.1 1.3775 17.1 1.9V15.2C17.1 15.7225 16.914 16.1698 16.5419 16.5419C16.1698 16.914 15.7225 17.1 15.2 17.1H8.55ZM6.65 13.3L5.34375 11.9225L7.76625 9.5H0V7.6H7.76625L5.34375 5.1775L6.65 3.8L11.4 8.55L6.65 13.3Z" fill="currentColor"/></svg> },
    { id: "checkout",  label: "Check-Out", icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H9V2H2V16H9V18H2ZM13 14L11.625 12.55L14.175 10H6V8H14.175L11.625 5.45L13 4L18 9L13 14Z" fill="currentColor"/></svg> },
    { id: "analytics", label: "Analytics", icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M4 14H6V9H4V14ZM12 14H14V4H12V14ZM8 14H10V11H8V14ZM8 9H10V7H8V9ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16Z" fill="currentColor"/></svg> },
    { id: "settings",  label: "Settings",  icon: <svg width="21" height="20" viewBox="0 0 21 20" fill="none"><path d="M7.3 20L6.9 16.8C6.68333 16.7167 6.47917 16.6167 6.2875 16.5C6.09583 16.3833 5.90833 16.2583 5.725 16.125L2.75 17.375L0 12.625L2.575 10.675C2.55833 10.5583 2.55 10.4458 2.55 10.3375V9.6625C2.55 9.55417 2.55833 9.44167 2.575 9.325L0 7.375L2.75 2.625L5.725 3.875C5.90833 3.74167 6.1 3.61667 6.3 3.5C6.5 3.38333 6.7 3.28333 6.9 3.2L7.3 0H12.8L13.2 3.2C13.4167 3.28333 13.6208 3.38333 13.8125 3.5C14.0042 3.61667 14.1917 3.74167 14.375 3.875L17.35 2.625L20.1 7.375L17.525 9.325C17.5417 9.44167 17.55 9.55417 17.55 9.6625V10.3375C17.55 10.4458 17.5333 10.5583 17.5 10.675L20.075 12.625L17.325 17.375L14.375 16.125C14.1917 16.2583 14 16.3833 13.8 16.5C13.6 16.6167 13.4 16.7167 13.2 16.8L12.8 20H7.3ZM10.1 13.5C11.0667 13.5 11.8917 13.1583 12.575 12.475C13.2583 11.7917 13.6 10.9667 13.6 10C13.6 9.03333 13.2583 8.20833 12.575 7.525C11.8917 6.84167 11.0667 6.5 10.1 6.5C9.11667 6.5 8.2875 6.84167 7.6125 7.525C6.9375 8.20833 6.6 9.03333 6.6 10C6.6 10.9667 6.9375 11.7917 7.6125 12.475C8.2875 13.1583 9.11667 13.5 10.1 13.5Z" fill="currentColor"/></svg> },
  ];
  return (
    <aside className="sidebar">
      <nav>
        {items.map(item => (
          <div key={item.id} className={`menu-item${activeNav === item.id ? " active" : ""}`} 
          onClick={() => {
  setActiveNav(item.id);

  if (item.id === "dashboard") {
    setPage("dashboard");
  }

  if (item.id === "vehicles") {
    setPage("vehicle");
  }

  if (item.id === "checkin") {
    setPage("checkin");
  }

  if (item.id === "checkout") {
    setPage("checkout");
  }

  if (item.id === "analytics") {
    setPage("analytics");
  }

  if (item.id === "settings") {
    setPage("settings");
  }
}}>
            {item.icon}<span>{item.label}</span>
          </div>
        ))}
      </nav>
    </aside>
  );
}
//sidebar over


export default function Checkout({ setPage }) {
  const [paymentMethod, setPaymentMethod] = useState("Cash");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [currentPage, setCurrentPage] = useState("checkout");
  const [activeMenu, setActiveMenu] = useState("Check-Out");

  if (currentPage === "vehicleList") {
  return (
    <VehicleListPage
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  setPage={setPage}
/>
  );
}

  return (
    <div className="checkout-page">
      {/* Sidebar */}
     <Sidebar
  activeNav="checkout"
  setActiveNav={() => {}}
  setPage={setPage}
/>

      {/* Main */}
      <main className="checkout-content">
        <h1>Finalize Check-Out</h1>
        <p className="checkout-subtitle">
          FINALISE AND EXIT THE VEHICLE FROM PARKING
        </p>

        <div className="cards-layout">
          {/* Left Side */}
          <div className="checkout-left-column">
            <div className="summary-card">
              <div className="checkout-card-title">Session Summary</div>

              <div className="checkout-row">
                <span>Vehicle Number</span>
                <strong>TN-68-AH9786</strong>
              </div>

              <div className="checkout-row">
                <span>Check-in Time</span>
                <strong>Oct 24, 08:30 AM</strong>
              </div>

              <div className="checkout-row">
                <span>Check-out Time</span>
                <strong>Oct 24, 12:42 PM</strong>
              </div>

              <div className="checkout-row">
                <span>Total Duration</span>
                <strong className="blue">4h 12m</strong>
              </div>

              <div className="checkout-row">
                <span>Rate Tier</span>
                <span className="checkout-badge">BUSINESS DAY</span>
              </div>
            </div>

            <div className="checkout-timer-card">
              <p className="small-text">SESSION TERMINATED</p>

              <h2>04:12:35</h2>

              <p className="total">Total Parking Duration</p>

              <div className="time-boxes">
                <div className="time-box">
                  <span>CHECK-IN</span>
                  <strong>08:45 AM</strong>
                </div>

                <div className="time-box">
                  <span>CHECK-OUT</span>
                  <strong>12:57 PM</strong>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="billing-card">
            <div className="billing-header">
              <h3>Billing Details</h3>

              <div className="amount-due">
                <span>TOTAL AMOUNT DUE</span>
                <h2>₹250</h2>
              </div>
            </div>

            <div className="payment-options">
  <button
    className={`checkout-payment ${paymentMethod === "Cash" ? "checkout-active-pay" : ""}`}
    onClick={() => setPaymentMethod("Cash")}
  >
    <Wallet size={22} />
    <span>Cash</span>
  </button>

  <button
    className={`checkout-payment ${paymentMethod === "Debit Card" ? "checkout-active-pay" : ""}`}
    onClick={() => setPaymentMethod("Debit Card")}
  >
    <CreditCard size={22} />
    <span>Debit Card</span>
  </button>

  <button
    className={`checkout-payment ${paymentMethod === "E-Wallet" ? "checkout-active-pay" : ""}`}
    onClick={() => setPaymentMethod("E-Wallet")}
  >
    <Smartphone size={22} />
    <span>E-Wallet</span>
  </button>
</div>

            <div className="amount-section">
              <div>
                <label>Amount Received</label>
                <div className="amount-box">₹ 300.00</div>
              </div>

              <div>
                <label>Balance to Return</label>
                <div className="amount-box-outline">₹ 50</div>
              </div>
            </div>

            <button
  className="complete-btn"
  onClick={() => setShowSuccessModal(true)}
>
  <Printer size={18} />
  <span>Complete Check-Out & Print Receipt</span>
</button>

            <button className="cancel-btn">
              x Cancel Transaction
            </button>
          </div>
        </div>
      </main>

      {showSuccessModal && (
  <div className="modal-overlay">
    <div className="success-modal">

      <img
        src={image}
        alt="company logo"
        className="success-image"
      />

      <h2>Checkout Completed</h2>

      <p>
        The vehicle is successfully exited from the
        parking
      </p>

      <div className="modal-buttons">

        <button
          className="dashboard-btn"
          onClick={() => setShowSuccessModal(false)}
        >
          Back to Dashboard
        </button>

        <button
  className="another-btn"
  onClick={() => {
    setShowSuccessModal(false);
    setCurrentPage("vehicleList");
  }}
>
  + Check-Out Another
</button>

      </div>

    </div>
  </div>
)}
    </div>
  );
}